module.exports = __webpack_public_path__ + "img/icon-none.7d6d119c.svg";